import { TemplateRef } from '@angular/core';

export enum AppearCondition {
    always,
    noSuggestions,
    noExactMatchInSuggestions
}

export class AutocompleteCustomOption {
    // The localization string for label or labelHtml will be
    // localized with the "query" field as the text typed in the
    // autocomplete.  So this can be used by callers to add the
    // query to their label.  Currently the main use case is for the label
    // "create new item [query]" for auto creation.
    label?: string;
    labelHtml?: string;
    labelTemplate?: TemplateRef<any>;
    labelTemplateVariable?: any;
    showDivider?: boolean = false;

    // TODO : return void|Promise<void>|Observable<void>
    // so that the autocomplete can set its loading animation during the action()
    action?: (query: string) => void;
    clearOnSelect: boolean = false;
    appearCondition: AppearCondition = AppearCondition.always;

    // PrimeAutocompleteComponent - selectItem() does not respect custom option searchkeyword
    preferSearchkeyword?: boolean = false;

    // Internal
    searchString?: string;
}
